import React from "react";
import { ReactComponent as Print } from "../../../../assets/icons/print.svg";

export function PafRenewActionButtons({
  auxButtons = false,
  isApprovedPAFCompleted,
  onPrint,
  onCancelStep,
  onPrimaryClick,
  onFinish,
}) {
  return (
    <div data-testid="paf-renew-action-buttons">
      {auxButtons &&
        (isApprovedPAFCompleted ? (
          <button
            type="button"
            onClick={onPrint}
            className="prev mr-4"
            data-testid="paf-renew-print-button"
          >
            Print <Print />
          </button>
        ) : (
          <button
            type="button"
            onClick={onCancelStep}
            className="prev mr-4"
            data-testid="paf-renew-cancel-button"
          >
            Cancel
          </button>
        ))}

      <button
        type="button"
        className="second-button mr-4"
        style={{ width: "160px" }}
        onClick={isApprovedPAFCompleted ? onFinish : onPrimaryClick}
        data-testid={
          isApprovedPAFCompleted
            ? "paf-renew-finish-button"
            : "paf-renew-complete-button"
        }
      >
        {isApprovedPAFCompleted ? "Finish" : "Complete"}
      </button>
    </div>
  );
}
